import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

import { type OperationalOnboardingLocationKey } from '../../models';

export const useMarkLocationAsViewedMutation = (
  location: OperationalOnboardingLocationKey,
  // eslint-disable-next-line @typescript-eslint/ban-types
): MutationState<{}> => {
  const companyId = useCompanyId();

  // eslint-disable-next-line @typescript-eslint/ban-types
  return useMutation<{}>({
    request: {
      type: 'rest',
      method: 'post',
      target: 'companyAPI',
      endpoint: `/onboarding-tasks/location/${location}/viewed`,
    },
    options: {
      onSuccess: ({ client }): void => {
        client.invalidateQueries(['welcomeDashboard', companyId]);
      },
    },
  });
};
